import { CheckmarkWithBackground, CloseIconWithCircle } from '@va/icons';
import { fontWeights, ParagraphWithTooltip } from '@va/ui/design-system';

export const PlanInfoChip = ({ text, checked }: { text: string; checked: boolean }) => {
  return (
    <div className='bg-white-snow rounded-18 flex items-center gap-6px p-6px'>
      {checked ? (
        <CheckmarkWithBackground color={'#F66F1E'} className='shrink-0' />
      ) : (
        <CloseIconWithCircle color='#696969' className='shrink-0' />
      )}
      <ParagraphWithTooltip
        weight={fontWeights.medium}
        colorClassName={checked ? 'text-gray-charcoal' : 'text-gray-devil'}
      >
        {text}
      </ParagraphWithTooltip>
    </div>
  );
};
